import { useQuery } from '@tanstack/react-query';
import { getGlobalAlerts } from './getGlobalAlerts';
import { globalAlertQueryKeys } from '../model/queryKeys';

export const useGlobalAlerts = () =>
  useQuery({
    queryKey: globalAlertQueryKeys.summary(),
    queryFn: getGlobalAlerts,
    refetchOnWindowFocus: false,
    retry: false,
  });